import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from '@phosphor-icons/react';

const ContactBanner = ({ 
  title = "Klaar om te beginnen?", 
  description = "Neem contact op en laten we samen kijken naar jouw project.", 
  buttonText = "Neem Contact Op", 
  buttonLink = "/contact" 
}) => {
  return (
    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-2xl my-32 p-8 sm:p-12 border border-blue-200">
      <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left gap-8">
        <div className="max-w-2xl">
          <h2 className="text-3xl font-bold text-gray-900">{title}</h2>
          <p className="text-gray-700 mt-2">{description}</p>
        </div>
        <div className="mt-6 md:mt-0 shrink-0">
          <Link
            to={buttonLink}
            className="inline-flex items-center gap-2 bg-gradient-to-r from-blue-600 to-indigo-700 hover:from-blue-700 hover:to-indigo-800 text-white px-6 py-3 rounded-lg transition-all duration-300 font-semibold group shadow-md hover:shadow-lg"
          >
            {buttonText}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ContactBanner; 